// Top App Bar Functionality
(function() {
  'use strict';

  // Check if localStorage is available
  function isLocalStorageAvailable() {
    try {
      const test = '__localStorage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  // Detect iOS device
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  // Initialize app bar
  function initAppBar() {
    const appBar = document.querySelector('.top-app-bar');
    const appBarClose = document.querySelector('.top-app-bar .close-bar');
    const appBarLink = appBar?.querySelector('a');

    if (!appBar || !appBarLink) return;

    // Set app store URL based on device
    const appStoreURL = isIOS()
      ? 'https://itunes.apple.com/in/app/mypoojabox/id1271217214?mt=8'
      : 'https://play.google.com/store/apps/details?id=com.androidapp.mypoojabox';

    appBarLink.setAttribute('href', appStoreURL);

    // Show app bar for Android if not previously closed
    if (!isIOS() && isLocalStorageAvailable()) {
      const wasClosed = localStorage.getItem('app-bar-close');
      if (!wasClosed) {
        appBar.classList.remove('hidden');
      }
    }

    // Handle close button click
    if (appBarClose) {
      appBarClose.addEventListener('click', function(e) {
        e.preventDefault();
        appBar.classList.add('hidden');
        
        if (isLocalStorageAvailable()) {
          localStorage.setItem('app-bar-close', 'true');
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppBar);
  } else {
    initAppBar();
  }
})();



